(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/rules.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/rules.js');

'use strict';

const _excluded = ["productId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let productMapping;
let rules;
let isSelfService;
let getNgConfig;





const rulesFunctions = {
  EUROJACKPOT: function () {
    var _config$eurojackpot;
    let {
      drawNumber
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const eurojackpotRules = isSelfService() ? rules.EUROJACKPOT_SELFSERVICE : rules.EUROJACKPOT;
    const config = getNgConfig();
    const firstDraw = config === null || config === void 0 || (_config$eurojackpot = config.eurojackpot) === null || _config$eurojackpot === void 0 || (_config$eurojackpot = _config$eurojackpot.ruleChange) === null || _config$eurojackpot === void 0 ? void 0 : _config$eurojackpot.firstDraw;
    if (!firstDraw || drawNumber && drawNumber < firstDraw) {
      return _objectSpread(_objectSpread({}, eurojackpotRules), {}, {
        numbersExtraMaxValue: 10
      });
    }
    return eurojackpotRules;
  },
  VIKINGLOTTO: () => isSelfService() ? rules.VIKINGLOTTO_SELFSERVICE : rules.VIKINGLOTTO,
  LOTTO: () => isSelfService() ? rules.LOTTO_SELFSERVICE : rules.LOTTO,
  KENO: () => isSelfService() ? rules.KENO_SELFSERVICE : rules.KENO
};

function getRules(product, options) {
  var _rulesFunctions$produ;
  if (typeof product === 'object') {
    var _product = product;
    ({
      productId: product
    } = _product);
    options = _objectWithoutProperties(_product, _excluded);
    _product;
  }
  return (_rulesFunctions$produ = rulesFunctions[productMapping.getProductId(product)]) === null || _rulesFunctions$produ === void 0 ? void 0 : _rulesFunctions$produ.call(rulesFunctions, options);
}
if (svs.isServer) {
  const path = require('path');
  rules = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, require(path.join(__dirname, 'eurojackpot.es6'))), require(path.join(__dirname, 'keno.es6'))), require(path.join(__dirname, 'lotto.es6'))), require(path.join(__dirname, 'vikinglotto.es6'))), require(path.join(__dirname, 'joker.es6')));
  const trinidadCore = require('trinidad-core').core;
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
  isSelfService = () => trinidadCore.config.options.isSelfService;
  getNgConfig = () => {
    var _trinidadCore$config$;
    return (_trinidadCore$config$ = trinidadCore.config.options.cms) === null || _trinidadCore$config$ === void 0 ? void 0 : _trinidadCore$config$.numbergames;
  };
  module.exports = {
    rules,
    getRules
  };
} else {
  isSelfService = () => svs.core.config.data.svsconfig.isSelfService;
  getNgConfig = () => {
    var _svs$numbergames$rule;
    return (_svs$numbergames$rule = svs.numbergames.rules.data) === null || _svs$numbergames$rule === void 0 ? void 0 : _svs$numbergames$rule.config;
  };
  ({
    rules,
    productMapping
  } = svs.numbergames);
  rules.getRules = getRules;
}

 })(window);